<script>
  import Button from '@components/buttons/button.svelte'
  import { cn } from '@lib/utils'
  
  let { label, value, path, children, column = false, class: className, valueClass = "", gap = "md", ...restProps } = $props()

  let gapClasses = {
    xs: "not-last:pb-1",
    sm: "not-last:pb-1.5",
    md: "not-last:pb-2",
    lg: "not-last:pb-2.5",
    xl: "not-last:pb-3",
  }

  let baseClasses = "flex justify-between text-gray-600/80 text-smaller not-last:border-b border-gray-100"
  let columnClasses = "flex flex-col gap-1"
  let rowClasses = "flex items-center gap-2"
  let classes = $derived(cn(baseClasses, column ? columnClasses : rowClasses, gapClasses[gap], className))
</script>

<div class={classes} {...restProps}>
  <p class="text-gray-600/70">{label}</p>
  {#if children}
    <div class="flex items-center gap-2">
      {@render children()}
    </div>
  {:else}
    {#if path}
      <Button variant="link" text={value} {path} />
    {:else}
      <p class={valueClass}>{value}</p>
    {/if}
  {/if}
</div>